// ============================================================
// DEPOIMENTOS — carrossel paginado com passagem automática
// Mostra 2 cartões por vez no desktop e 1 no celular, com
// contador de páginas e setas. Espelha o comportamento do
// layout aprovado (lp-redes-de-protecao-02.html), somando a
// passagem automática em laço.
// ============================================================

(function () {
    'use strict';

    var INTERVALO = 6000; // tempo de cada página, em milissegundos

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', iniciar);
    } else {
        iniciar();
    }

    function iniciar() {
        var carousel = document.querySelector('[data-testimonials]');
        if (!carousel) return;

        var track   = carousel.querySelector('.sec-testimonials__track');
        var cards   = Array.prototype.slice.call(carousel.querySelectorAll('.card-testimonial'));
        var current = carousel.querySelector('[data-testimonials-current]');
        var total   = carousel.querySelector('[data-testimonials-total]');
        var prev    = carousel.querySelector('[data-testimonials-prev]');
        var next    = carousel.querySelector('[data-testimonials-next]');

        if (!track || !cards.length) return;

        var page      = 0;
        var timer     = null;
        var maiorAlt  = 0;

        function perPage() {
            return window.matchMedia('(max-width: 780px)').matches ? 1 : 2;
        }

        function totalPages() {
            return Math.ceil(cards.length / perPage());
        }

        // Quem pediu menos animação no sistema não recebe passagem automática
        function animacaoReduzida() {
            return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        function render() {
            var size  = perPage();
            var start = page * size;
            var end   = start + size;

            cards.forEach(function (card, index) {
                card.hidden = !(index >= start && index < end);
            });

            if (current) current.textContent = page + 1;
            if (total)   total.textContent   = totalPages();

            // Com a passagem em laço as setas nunca travam — só desativam
            // quando existe uma única página.
            var travar = totalPages() < 2;
            if (prev) prev.disabled = travar;
            if (next) next.disabled = travar;

            travarAltura();
        }

        // Páginas com textos de tamanhos diferentes mudam de altura e fazem a
        // seção pular a cada passagem. O trilho fica na altura da maior página.
        function travarAltura() {
            track.style.minHeight = '';

            var altura = track.getBoundingClientRect().height;
            if (altura > maiorAlt) maiorAlt = altura;

            track.style.minHeight = maiorAlt + 'px';
        }

        // Anda em laço: da última página volta pra primeira
        function go(direcao) {
            var paginas = totalPages();
            page = (page + direcao + paginas) % paginas;
            render();
        }

        function tocar() {
            parar();
            if (totalPages() > 1 && !animacaoReduzida()) {
                timer = window.setInterval(function () { go(1); }, INTERVALO);
            }
        }

        function parar() {
            if (timer) {
                window.clearInterval(timer);
                timer = null;
            }
        }

        // Clique nas setas reinicia a contagem, pra não trocar logo em seguida
        if (prev) prev.addEventListener('click', function () { go(-1); tocar(); });
        if (next) next.addEventListener('click', function () { go(1);  tocar(); });

        // Pausa enquanto o visitante está lendo
        carousel.addEventListener('mouseenter', parar);
        carousel.addEventListener('mouseleave', tocar);
        carousel.addEventListener('focusin', parar);
        carousel.addEventListener('focusout', tocar);

        // Fora da tela não precisa girar
        document.addEventListener('visibilitychange', function () {
            if (document.hidden) parar(); else tocar();
        });

        window.addEventListener('resize', function () {
            page     = 0;
            maiorAlt = 0; // outra largura, outras alturas
            render();
            tocar();
        });

        render();
        tocar();
    }
})();
